"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var package_1 = require("@pbl/pbl-react-web-components/lib/package");
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var colorsV2_1 = __importDefault(require("../../../../assets/jss/colorsV2"));
var constants_1 = __importDefault(require("../../../../config/constants"));
var AccessibleDisabledButton_1 = __importDefault(require("../../../../shared/components/button/AccessibleDisabledButton"));
var PasswordStrengthIndicator_1 = __importDefault(require("../../../../shared/components/password/v2/PasswordStrengthIndicator"));
var validations_1 = require("../../validations");
var styles_1 = __importDefault(require("./styles"));
var PasswordResetForm = function (_a) {
    var onSubmit = _a.onSubmit, description = _a.description, disableAutofill = _a.disableAutofill;
    var theme = (0, core_1.useTheme)();
    var classes = (0, styles_1.default)(theme)();
    var t = (0, react_i18next_1.useTranslation)().t;
    var _b = (0, react_1.useState)(''), password = _b[0], setPassword = _b[1];
    var _c = (0, react_1.useState)(''), confirmPassword = _c[0], setConfirmPassword = _c[1];
    var _d = (0, react_1.useState)(true), emptyPassword = _d[0], setEmptyPassword = _d[1];
    var _e = (0, react_1.useState)(true), emptyConfirmPassword = _e[0], setEmptyConfirmPassword = _e[1];
    var _f = (0, react_1.useState)(false), passwordMismatchError = _f[0], setPasswordMismatchError = _f[1];
    var isMobile = (0, core_1.useMediaQuery)(theme.breakpoints.down('xs'));
    var handlePasswordChange = function (value) {
        setPassword(value);
        setEmptyPassword(value === '');
    };
    var handleConfirmPasswordChange = function (value) {
        setConfirmPassword(value);
        setEmptyConfirmPassword(value === '');
        setPasswordMismatchError(password !== value);
    };
    var canSubmit = function () {
        onSubmit(password);
    };
    var passwordErrors = validations_1.passwordValidatorSchema.validate(password, {
        list: true
    });
    var passwordFieldRole = 'textbox';
    var labelProps = function (field) {
        return {
            useAlternateTextField: true,
            isRequiredLabel: true,
            labelStyle: {
                margin: theme.spacing(2, 0, -2, 2),
                color: field ? colorsV2_1.default.palette.neutralsN700.hex() : colorsV2_1.default.palette.primaryP500.hex()
            },
            role: passwordFieldRole
        };
    };
    var labelPropsMobile = {
        useAlternateTextField: true,
        isRequiredLabel: true,
        labelStyle: { margin: theme.spacing(2, 0, -2, 0), color: colorsV2_1.default.palette.neutralsN700.hex() },
        role: passwordFieldRole
    };
    var activeButton = typeof passwordErrors !== 'boolean' &&
        passwordErrors &&
        passwordErrors.length === 0 &&
        !passwordMismatchError;
    var passwordField = {
        type: 'password',
        key: 'password',
        label: t('resetPassword.newPassword'),
        value: password,
        isRequired: true,
        showPassword: true,
        secureTextEntry: true,
        get fieldValue() {
            return password;
        },
        validationSchema: validations_1.passwordValidation,
        disabledAutofill: disableAutofill
    };
    var confirmPasswordField = {
        type: 'password',
        key: 'confirmPassword',
        label: t('resetPassword.confirmNewPassword'),
        value: confirmPassword,
        isRequired: true,
        showPassword: true,
        secureTextEntry: true,
        get fieldValue() {
            return confirmPassword;
        },
        validationSchema: validations_1.confirmPasswordValidation,
        disabledAutofill: disableAutofill
    };
    return (react_1.default.createElement(core_1.Box, { className: classes.mainContainer },
        react_1.default.createElement(core_1.Typography, { component: "h2", variant: "h2", className: classes.titleText }, t('resetPassword.title')),
        react_1.default.createElement(core_1.Typography, { variant: "body1", style: {
                fontSize: '18px',
                color: colorsV2_1.default.palette.neutralsN700.hex(),
                marginBottom: theme.spacing(5.5)
            } }, description !== null && description !== void 0 ? description : t('resetPassword.description')),
        react_1.default.createElement(core_1.Typography, { variant: "body2", style: { color: colorsV2_1.default.palette.neutralsN900.hex(), marginBottom: theme.spacing(5.5) } }, t('login.requiredInformation')),
        react_1.default.createElement(core_1.Box, { sx: { marginBottom: theme.spacing(4.5) } },
            react_1.default.createElement(package_1.FieldRenderer, { labelProps: !isMobile ? labelProps(emptyPassword) : labelPropsMobile, field: passwordField, onChange: handlePasswordChange, className: classes.field, inputProps: {
                    fullWidth: true,
                    variant: constants_1.default.FIELDS_VARIANT,
                    helperText: ''
                } })),
        react_1.default.createElement(PasswordStrengthIndicator_1.default, { password: password, passwordErrors: passwordErrors }),
        react_1.default.createElement(core_1.Box, { sx: { marginBottom: theme.spacing(4.5), marginTop: theme.spacing(4.5) } },
            react_1.default.createElement(package_1.FieldRenderer, { labelProps: !isMobile ? labelProps(emptyConfirmPassword) : labelPropsMobile, field: confirmPasswordField, onChange: handleConfirmPasswordChange, className: classes.field, inputProps: {
                    error: passwordMismatchError,
                    fullWidth: true,
                    variant: constants_1.default.FIELDS_VARIANT,
                    helperText: passwordMismatchError ? t('resetPassword.mismatchError') : ''
                } })),
        react_1.default.createElement(core_1.Box, { sx: { display: 'flex', justifyContent: 'center', width: '100%' } },
            react_1.default.createElement(AccessibleDisabledButton_1.default, { size: "large", variant: "contained", color: "primary", fullWidth: true, "aria-label": !activeButton
                    ? "".concat(t('resetPassword.title'), ". Please complete all required fields before submitting.")
                    : t('resetPassword.title'), onClick: canSubmit, disabled: !activeButton, className: classes.button }, t('resetPassword.title')))));
};
exports.default = PasswordResetForm;
//# sourceMappingURL=PasswordResetForm.js.map